import { Navigate, useRoutes } from 'react-router-dom';
import { AddressSearchPage } from 'pages/AddressSearch/AddressSearchPage';
import { MainLayout } from 'layouts/MainLayout';
import { CustomerTypeSelectionPage } from 'pages/CustomerTypeSelection/CustomerTypeSelectionPage';
import { CustomerSearchPage } from 'pages/CustomerSearch/CustomerSearchPage';
import { AvailabilityCheckPage } from 'pages/AvailabilityCheck/AvailabilityCheckPage';
import { RequireAddress } from 'components/router/RequireAddress';
import { ProvideSessionFttx } from 'components/router/ProvideSessionFttx';
import { AutoConfigCheckPage } from 'pages/AutoConfigurationCheck/AutoConfigCheckPage';
import { RequireVerifiedAddress } from 'components/router/RequireVerifiedAddress';

export const useFttxRoutes = () =>
    useRoutes([
        {
            element: <MainLayout />,
            children: [
                {
                    path: '/',
                    element: <ProvideSessionFttx />,
                    children: [
                        {
                            index: true,
                            element: <CustomerTypeSelectionPage />,
                        },
                        {
                            path: '/bestandskunden',
                            children: [
                                {
                                    index: true,
                                    element: <Navigate replace to="kundensuche" />,
                                },
                                {
                                    path: 'kundensuche',
                                    element: <CustomerSearchPage />,
                                },
                                {
                                    path: 'pruefe-adresse',
                                    element: (
                                        <RequireAddress redirectTo="../adresssuche">
                                            <AvailabilityCheckPage />
                                        </RequireAddress>
                                    ),
                                },
                                {
                                    path: 'adresssuche',
                                    element: <AddressSearchPage />,
                                },
                                {
                                    path: 'pruefe-produktkonfiguration',
                                    element: (
                                        <RequireVerifiedAddress redirectTo={'../kundensuche'}>
                                            <AutoConfigCheckPage />
                                        </RequireVerifiedAddress>
                                    ),
                                },
                            ],
                        },
                        {
                            path: '/neukunden',
                            children: [
                                {
                                    index: true,
                                    element: <Navigate replace to="pruefe-adresse" />,
                                },
                                {
                                    path: 'pruefe-adresse',
                                    element: (
                                        <RequireAddress redirectTo="../adresssuche">
                                            <AvailabilityCheckPage />
                                        </RequireAddress>
                                    ),
                                },
                                {
                                    path: 'adresssuche',
                                    element: <AddressSearchPage />,
                                },
                                {
                                    path: 'pruefe-produktkonfiguration',
                                    element: (
                                        <RequireVerifiedAddress redirectTo={'../adresssuche'}>
                                            <AutoConfigCheckPage />
                                        </RequireVerifiedAddress>
                                    ),
                                },
                            ],
                        },
                    ],
                },
                {
                    path: '*',
                    element: <Navigate to="/" replace />, // TODO provide an error page here later, e.g. <ErrorPage404 />,
                },
            ],
        },
    ]);
